import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Checkbox } from 'primeng/checkbox';
import { ScrBaseComponent } from '../../base.component';
import { ScrEnvironment } from '../../../../environments/environment';
import { AccountService, CreateAccountRequest } from '../../../services/account.service';
import { CreateAccountService } from '../../../services/createaccount.service';
import { NgControl, NgModel } from '@angular/forms';
import { Observable } from 'rxjs';
import { ScrAuthenticationService } from '../../../services/authentication.service';
import { Aggregator, ConfigService } from '../../../services/config.service';
import { ShortCodesRole } from '../../../models/constants';
import { Address } from '../../../services/address-book.service';
import { StringOrPhoneNumber } from 'src/app/models/common.model';
import { isArray } from 'lodash-es';
import { NgxIntlTelInputComponent } from '@scr/ngx-intl-tel-input';
import { handleEnterKeyPress } from 'src/app/shared/common-events';
import { DropdownChangeEvent } from 'primeng/dropdown';

@Component({
  templateUrl: './createaccount.component.html',
  styleUrls: ['./createaccount.component.scss']
})
export class CreateAccountComponent extends ScrBaseComponent implements OnInit {
  CognitoGroup: typeof ShortCodesRole = ShortCodesRole;
  JSON = JSON;
  public phoneBeingSaved?= '';

  public model = new CreateAccountRequest();
  public steps: string[] = [
    'Personal Information',
    'Organization Information',
    'Billing Information',
    'Program Type'
  ];
  public submitted = false;
  public isDisplay = false;
  public updateOrdersApplicantContact = false;
  public updateOrdersBillingContact = false;
  public step = 0;
  public termAgreement = false;
  public bestPractices?: boolean;
  public captcha = '';
  public recaptchaEnabled = false;
  @ViewChild('termAgreement') termAgreementcheckbox?: Checkbox;

  public confirmPasswordFocused = false;
  public dummy: {
    password?: string,
    email?: string,
    governmentTerms: boolean,
    charityTerms: boolean

  } = { password: '', governmentTerms: false, charityTerms: false };

  public licenseAgreementDate?: string;
  public licenseAgreementcontent?: string;
  public bestPracticesContent?: string;
  public bestPracticesDate?: string;
  public aggregators: Aggregator[] = [];
  public ecosystemRoles!: string[];

  public billingOnRenew = [{
    label: 'Billing Info on previous order',
    value: false
  }, {
    label: 'Primary Billing Contact from the account information',
    value: true
  }];

  @ViewChild('billingCountry') billingCountry?: NgModel;
  @ViewChild(NgxIntlTelInputComponent) billingPhone?: NgxIntlTelInputComponent;

  public legalEntityTypes!: string[];
  public publicEmailDomains: string[] = [];

  constructor(
    private router: Router,
    public service: ScrAuthenticationService,
    public createAccountService: CreateAccountService,
    public accountService: AccountService,
    public configService: ConfigService,
    public env: ScrEnvironment) {
    super();
  }

  ngOnInit(): void {

    const queryString = window.location.search;
    if (queryString) {
      const urlParams = new URLSearchParams(queryString);
      this.step = parseInt(urlParams.get('step') ?? '0');
    }
    this.configService.getConfig().subscribe(cfg => {
      this.recaptchaEnabled = cfg.recaptchaEnabled;
      this.licenseAgreementDate = cfg.licenseAgreement.updated;
      this.licenseAgreementcontent = cfg.licenseAgreement.content;
      this.legalEntityTypes = cfg.legalEntityTypes;
      this.ecosystemRoles = cfg.ecosystemRoles;
      this.publicEmailDomains = cfg.publicEmailDomains;
      this.bestPracticesContent = cfg.bestPractices.content;
      this.bestPracticesDate = cfg.bestPractices.updated;
    });

    // selected by default
    this.model.programTypeRequested = 'Standard';

    this.model.accountBillingOnRenew = false;
    this.model.country = 'us';
    this.model.billingCountry = 'us';
    this.configService.getAggregators().subscribe(res => {
      this.aggregators = res.filter(aggregator => aggregator.aggregatorId !== 9999);
    });
  }

  phoneValidate(): void {
    this.phoneBeingSaved = (typeof this.model.phone === 'object') ? this.model.phone.e164Number : this.model.phone;
  }
  advance(): void {
    this.step++;
    window.scrollTo(0, 0);
  }

  copyBillingInfo(copy: boolean) {
    if (!copy)
      return;

    this.model.billingFirstName = this.model.firstName;
    this.model.billingLastName = this.model.lastName;
    this.model.billingPhone = this.model.phone;
    this.model.billingPhoneExtension = this.model.phoneExtension;
    this.model.billingEmail = this.model.email;
    this.model.billingAddress1 = this.model.address1;
    this.model.billingAddress2 = this.model.address2;
    this.model.billingCity = this.model.city;
    this.model.billingState = this.model.state;
    this.model.billingZip = this.model.zip;
    this.model.billingCountry = this.model.country;
    /*window.setTimeout(() => { */this.model.billingZip = this.model.zip/* }, 0)*/;
  }

  loadAddress(address: Address) {
    this.model.billingFirstName = address.firstName;
    this.model.billingLastName = address.lastName;
    this.model.billingPhone = address.phone;
    this.model.billingPhoneExtension = address.phoneExtension;
    this.model.billingEmail = address.email;
    this.model.billingAddress1 = address.address1;
    this.model.billingAddress2 = address.address2;
    this.model.billingCity = address.city;
    this.model.billingState = address.state;
    this.model.billingZip = address.zip;
    this.model.billingCountry = address.country;
  }

  checkUsername(username: NgControl): Observable<boolean> {
    return new Observable<boolean>(subscriber => {
      this.createAccountService.checkUserId(username.value).subscribe(data => {
        if (data.status != 'success')
          this.processScrErrorResponse(data);
        subscriber.next(data.userExists ?? false);
      }, error => {
        if (error.status == '429') {
          subscriber.error(error);
        } else {
          this.processHttpError(error);
        }
      });
    });
  }

  checkEmail(email: NgControl): Observable<boolean> {
    return new Observable<boolean>(subscriber => {
      this.createAccountService.checkEmail(email.value).subscribe(data => {
        if (data.status != 'success')
          this.processScrErrorResponse(data);
        subscriber.next(data.emailExists ?? false);
      }, error => { this.processHttpError(error); });
    });
  }

  focusConfirmPassword() {
    this.confirmPasswordFocused = true;
  }

  blurConfirmPassword() {
    this.confirmPasswordFocused = false;
  }

  passwordResult(): string {
    const password = this.model.password || '';

    const long = (s: string) => s.length > 8;
    const containsUpper = (s: string) => !!s.match(/[A-Z]/);

    if (long(password))
      return containsUpper(password) ? 'strong' : 'fair';
    else
      return containsUpper(password) ? 'fair' : 'weak';
  }

  agencyTypeChanged() {
    delete this.model.governmentExplain;
  }

  programTypeChanged() {
    this.model.governmentAgencyType = '';
    this.model.governmentExplain = '';
    this.model.governmentAgencyWebsite = '';
    this.model.governmentAdditionalInfo = '';
    this.dummy.governmentTerms = false;
    this.model.charityAccreditation = '';
    this.model.charityAdditionalInfo = '';
    this.dummy.charityTerms = false;
  }

  stepBack(step: number, valid: boolean) {
    if (valid)
      this.step = step;
  }

  modelData(): CreateAccountRequest {

    const ret: Record<string, StringOrPhoneNumber | number | string | boolean | string[] | number[] | null> = { ...this.model };

    if (ret.phone && typeof ret.phone === 'object' && !isArray(ret.phone)) {
      ret.phone = ret.phone.e164Number;
    }

    if (ret.secondaryPhone && typeof ret.secondaryPhone === 'object' && !isArray(ret.secondaryPhone)) {
      ret.secondaryPhone = ret.secondaryPhone.e164Number;
    }

    if (ret.billingPhone && typeof ret.billingPhone === 'object' && !isArray(ret.billingPhone)) {
      ret.billingPhone = ret.billingPhone.e164Number;
    }

    if (ret.governmentAgencyType !== 'Other')
      ret.governmentExplain = '';

    for (const i in ret) {
     // the if previously had this extra clause: && ret[i] !== false.  
     // How could it be both equal to an empty string and be of type boolean.
      if (ret[i] === '') {
        ret[i] = null;
      }
    }

    if (typeof ret.company === 'string')
      ret.company = ret.company.trim();
  
    return ret;
  }

  createAccount() {
    this.clearMessages();
    this.observe(this.createAccountService.createAccount(this.modelData(), this.captcha), (() => {
      this.router.navigate(['/sec/verify']);
    }));
  }

  /**
   * Create account is the only page (at the moment) where the selection of country in the short codes country
   * dropdown (billingCountry) provides the country value for billing phone if the phone has not been populated.
   */
  billingCountryChanged(): void {
    if (this.billingPhone && this.billingCountry) {
      if (!this.billingPhone.value) {
        // find a matching country.
        const country = this.billingPhone.allCountries.find(c => c.iso2 === this.billingCountry?.model);
        if (country) {
          this.billingPhone.setSelectedCountry(country);
        }
        else {
          this.log.warn(`cannot find matching country in allCountries for ${this.billingCountry?.model}`);
        }
      }
    }
  }

  handleEnter(event: Event){
    handleEnterKeyPress(event);
  }

  onChangeDropdown(event: DropdownChangeEvent) {
    if (!event.value)
      this.model.legalEntityType = undefined;
  }
}
